import type { ReactNode } from "react"
import { cn } from "@/shared/lib/utils"
import { Label } from "@/shared/ui/label"

/** Форма ошибки проверки графа, достаточная для показа под полем: не тянем весь GraphIssue. */
export interface FieldIssue {
	code: string
	message: string
	severity: "error" | "warning"
	path?: string | null
}

export function IssueText({ issues }: { issues: FieldIssue[] }) {
	if (issues.length === 0) return null
	const hasError = issues.some((issue) => issue.severity === "error")
	return (
		// data-issue: цель перехода «к ошибке» из шапки панели блока.
		<div className="space-y-0.5" data-issue={hasError ? "error" : "warning"}>
			{issues.map((issue, index) => (
				<p
					key={`${issue.code}-${index}`}
					className={cn(
						"text-xs",
						issue.severity === "error" ? "text-destructive" : "text-yellow-400",
					)}
				>
					{issue.message}
				</p>
			))}
		</div>
	)
}

export function Field({
	label,
	hint,
	issues = [],
	htmlFor,
	children,
}: {
	label: string
	hint?: ReactNode
	issues?: FieldIssue[]
	htmlFor?: string
	children: ReactNode
}) {
	return (
		<div className="space-y-1.5">
			<Label htmlFor={htmlFor} className="text-sm font-medium text-foreground/90">
				{label}
			</Label>
			{children}
			{hint ? <p className="text-sm leading-snug text-muted-foreground">{hint}</p> : null}
			<IssueText issues={issues} />
		</div>
	)
}
